<app-core>
  <router-outlet />
</app-core>
